var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sw-chart', (_vm.isDarkTheme + "?'sw-chart--dark':''")],staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.chartId}},[_vm._v("\n  Chart Area\n")])}
var staticRenderFns = []

export { render, staticRenderFns }